import { post } from '../utils/http';
import { APIResponse } from '../types/api-response';
import { Organisation } from '../types/organisation';

export interface GetOrganisationsResponse {
  organisations: {
    name: string,
    organisation_id: string,
    shard_id: string,
    tenant_id: string
  }[];
}

export async function getOrganisations(token: string): Promise<APIResponse<GetOrganisationsResponse>> {
  return await post('1.0/auth/profile', { token });
}

export async function getAllOrganisations(token: string): Promise<APIResponse<Organisation[]>> {
  return await post('1.0/admin/organisations', { token });
}

export async function updateOrganisationState(token: string, orgId: string, deactivate: boolean): Promise<APIResponse> {
  return await post('1.0/admin/setorganisationstate', { token, orgId, deactivate });
}

export async function updateMemberState(
  token: string, 
  orgId: string, 
  memberId: string, 
  active: boolean
): Promise<APIResponse> {
  return await post('1.0/admin/setmemberstate', { token, memberId, orgId, active });
}